export default function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center animate-fade-in" data-testid="empty-state">
      {Icon && (<div className="w-16 h-16 rounded-2xl bg-accent flex items-center justify-center mb-4"><Icon className="w-7 h-7 text-muted-foreground" /></div>)}
      <h3 className="font-semibold text-foreground mb-1">{title}</h3>
      <p className="text-sm text-muted-foreground max-w-xs">{description}</p>
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
